export default function isLocationActive({ isOwner, hasEntitlements }) {
  const locationConstraints = [isOwner, hasEntitlements];
  return locationConstraints.every(Boolean);
}
